<div *ngIf="componentType == 1">
    <rx-general-tabs></rx-general-tabs>
</div>

<div *ngIf="componentType == 2">
    <app-order-add (myStepFinished)="orderAddFinished($event)" [orderType]="2"></app-order-add>
</div>
<!-- //////////////////////////////////laboratory -->
<div *ngIf="componentType == 3">
    <app-order-add (myStepFinished)="orderAddFinished($event)" [orderType]="1"></app-order-add>
</div>

<div *ngIf="componentType == 4">
    <app-emr-allergy></app-emr-allergy>
</div>

<!-- <div *ngIf="componentType == 5">
    <service-charging></service-charging>
</div> -->

<!-- <div *ngIf="componentType == 6">
    <app-service-history [openedAs]="'TAP'"></app-service-history>
</div> -->

<div *ngIf="componentType == 7">
    <emrPatVitals [displayType]="displayType" [patientAge]="patientAgeObj"></emrPatVitals>
</div>

<div *ngIf="componentType == 10">
    <emr-glass-card [displayType]="2" [dataType]="1"></emr-glass-card>
</div>

<div *ngIf="componentType == 11">
    <emr-glasgow-coma-scale [displayType]="2" [dataType]="1"></emr-glasgow-coma-scale>
</div>

<div *ngIf="componentType == 12">
    <emr-behavioral-pain-scale [displayType]="2" [dataType]="1"></emr-behavioral-pain-scale>
</div>

<div *ngIf="componentType == 13">
    <emr-nonverbal-pain-scale [displayType]="3"></emr-nonverbal-pain-scale>
</div>

<div *ngIf="componentType == 14">
    <app-order-add (myStepFinished)="orderAddFinished($event)" [orderType]="orderType"></app-order-add>
</div>
<!-- ccccccccc order without type -->
<div *ngIf="componentType == 15">
    <app-order-add (myStepFinished)="orderAddFinished($event)" ></app-order-add>
</div>
<!-- <div *ngIf="componentType == 15">app-service-history
    <emr-pregnant [displayType]="3"></emr-pregnant>
</div> -->

<!-- <div *ngIf="componentType == 15">
    <emr-vital-charts [autoSave]="false" [chartName]="'FLUIDS'" [_UIKey]="'2437'"></emr-vital-charts>
</div> -->

<!--/////// More Details for Patient (IN=100 - OUT=200 - ER=300) \\\\\\\-->


<div *ngIf="componentType == 400 || componentType == 123 || componentType == 234">
    <div class="body" style="display:none">
        <div id="section123dfhdfjksdkl">
            <div class="wrapper" [ngClass]="{'left-to-right': translate.currentLang != 'ar', 'right-to-left': translate.currentLang == 'ar'}">
                <table class="full-width " *ngIf="componentType == 400">
                    <tr style="vertical-align:top;">
                        <td colspan="6" class="reportTitle_ar custom-head-color">{{ 'MEDICALFILE' | translate }}</td>
                    </tr>
                    <tr style="vertical-align:top;">
                        <td colspan="6" class="tr-as-line"></td>
                    </tr>
                </table>
                <table class="full-width table-custom" *ngIf="componentType == 400">
                    <tbody>
                        <div class="card-group row">
                            <div class="card card-outline-primary b col-sm-12">
                                <div class="card-block">
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar"><strong class="bold-custom">{{ 'PATCODE' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar" style="color: black;font-weight: 900;">
                                            {{patient?.patCode}}</td>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'PATNAMEAR' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{translate.currentLang == 'ar' ? patient?.fullnameAr : patient?.fullnameEn}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'BIRTHDATE' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">{{patient?.birthDate | date :'yyyy-MM-dd'}}
                                        </td>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'NATIONALITY' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{translate.currentLang == 'ar' ? patient?.nationalityAr : patient?.nationalityEn}}
                                        </td>
                                    </tr>
                                </div>
                            </div>
                            <div class="card card-outline-primary c col-sm-12">
                                <div class="card-block">
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar"><strong class="bold-custom">{{'ADDRESS' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{translate.currentLang == 'ar' ? patient?.fullAddressAr : patient?.fullAddressEn}}
                                        </td>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'MOBILENUMBER' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">{{patient?.mobile}}</td>
                                    </tr>
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar" *ngIf="componentType == 400">
                                            <strong class="bold-custom">{{'Contract' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar" *ngIf="componentType == 400">
                                            {{translate.currentLang == 'ar' ? patient?.contractsAr : patient?.contractsEn}}
                                        </td>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'IDENTITYVALUE' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">{{patient?.identityValue}}</td>
                                    </tr>
                                </div>
                            </div>
                            <div class="card card-outline-primary c col-sm-12">
                                <div class="card-block">
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar" *ngIf="componentType == 123 || componentType == 234">
                                            <strong class="bold-custom">{{'PLACE'| translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar" *ngIf="componentType == 123 || componentType == 234">
                                            {{translate.currentLang == 'ar' ? patient?.branchNameAr : patient?.branchNameAr}}
                                        </td>
                                        <td class="groupHeaderLabelCell_ar" *ngIf="componentType == 400">
                                            <strong class="bold-custom">{{'DOCTOR' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar" *ngIf="componentType == 400">
                                            {{translate.currentLang == 'ar' ? patient?.docNameAr : patient?.docNameEn}}
                                        </td>
                                        <td class="groupHeaderLabelCell_ar" *ngIf="componentType == 400">
                                            <strong class="bold-custom">{{'PLACENAME' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar" *ngIf="componentType == 400">
                                            {{translate.currentLang == 'ar' ? patient?.placeNameAr : patient?.placeNameEn}}
                                        </td>
                                    </tr>
                                </div>
                            </div>
                        </div>
                    </tbody>
                </table>
                <div class="main-tables" *ngIf="componentType == 400 && vitalsData  ">
                    <!-- vital data -->
                    <general-table [data]="vitalsData" [title]="'PATIENTVITALSDATA'" [docId]="patient?.docId" [type]="'t01'" [headColumns]="['VSPULSE','VSBP','VSTEMP', 'OXYOGENLEVEL', 'BLOODSUGER', 'VSRR', 'VSHEIGHT', 'VSWEIGHT', 'Notes', 'USERNAME', 'RegDate']" [bodyColumns]="['pulse', 'highPressure', 'temperature','sat', 'bloodSuger', 'respiratory', 'height', 'weight', 'notes', 'userName', 'regDate']">
                    </general-table>
                    <!-- all data from emr-doctor data object {diag - complain - find} -->
                    <div *ngFor="let table of tables">
                        <general-table [data]="emrPatData[table.datakey]" [title]="table.title" [docId]="patient?.docId" [headColumns]="table.headColumns" [type]="table.type" [bodyColumns]="table.bodyColumns">
                        </general-table>
                    </div>
                </div>
                <div *ngIf="componentType == 123 || componentType == 234" style="height: 96px;"></div>
                <div class="d-flex" [ngClass]="{'left-to-right': translate.currentLang != 'ar', 'right-to-left': translate.currentLang == 'ar'}">
                    <p lang="ar" style="padding: 0px 90px;">
                        {{translate.currentLang == 'ar'? patient?.fullnameAr : patient?.fullnameAr}}</p>
                    <p style="margin-right: auto;letter-spacing: 1.5px;" [ngStyle]="{'margin':translate.currentLang == 'ar' ? '0 auto 0 60px' : '0 60px 0 auto' }">
                        {{patient?.startDate | date: 'dd/MM/yyyy'}}</p>
                </div>
                <div class="main-tables" *ngIf="componentType == 123 || componentType == 234">
                    <!-- radiology data -->
                    <div *ngIf="componentType == 234">
                        <div style="padding: 2px 15px;" *ngFor="let rad of filteredRadData">
                            <span class="text-left px-5">
                                - {{translate.currentLang == 'ar'? rad.serviceNameAr : rad.serviceNameEn}}
                            </span>
                        </div>
                    </div>
                    <!-- laboratory data -->
                    <div *ngIf="componentType == 123">
                        <div style="padding: 2px 15px;" *ngFor="let lab of filteredLabData">
                            <span class="text-left px-5">
                                - {{translate.currentLang == 'ar'? lab.serviceNameAr : lab.serviceNameEn}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-print-page #printComponent section="section123dfhdfjksdkl"></app-print-page>
</div>

<div *ngIf="componentType == 500" class="container-fluid">
    <div class="body" style="display:none">
        <div id="sectionwewe23232332">
            <div class="wrapper" [ngClass]="{'left-to-right': translate.currentLang != 'ar', 'right-to-left': translate.currentLang == 'ar'}">
                <table class="full-width ">
                    <tr style="vertical-align:top;">
                        <td colspan="6" class="reportTitle_ar custom-head-color">{{ 'MEDICALFILE' | translate }}
                        </td>
                    </tr>
                    <tr style="vertical-align:top;">
                        <td colspan="6" class="tr-as-line"></td>
                    </tr>
                </table>
                <table class="full-width table-custom">
                    <tbody>
                        <div class="card-group row">
                            <div class="card card-outline-primary b col-sm-12">
                                <div class="card-block">
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar"><strong class="bold-custom">{{ 'PATCODE' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar" style="color: black;font-weight: 900;">
                                            {{patient?.patCode}}</td>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'PATNAMEAR' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{translate.currentLang == 'ar' ? patient?.fullnameAr : patient?.fullnameEn}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'Contract' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{translate.currentLang == 'ar' ? patient?.contractsAr : patient?.contractsEn}}
                                        </td>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'IDENTITYVALUE' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">{{patient?.identityValue}}</td>
                                    </tr>
                                </div>
                            </div>

                            <div class="card card-outline-primary c col-sm-12">
                                <div class="card-block">
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'BIRTHDATE' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{patient?.birthDate | date :'yyyy-MM-dd'}}
                                        </td>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'NATIONALITY' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{translate.currentLang == 'ar' ? patient?.nationalityAr : patient?.nationalityEn}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar"><strong class="bold-custom">{{'ADDRESS' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{translate.currentLang == 'ar' ? patient?.fullAddressAr : patient?.fullAddressEn}}
                                        </td>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'MOBILENUMBER' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">{{patient?.mobile}}</td>
                                    </tr>
                                </div>
                            </div>
                            <div class="card card-outline-primary c col-sm-12">
                                <div class="card-block">
                                    <tr>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'DOCTOR' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{translate.currentLang == 'ar' ? patient?.docNameAr : patient?.docNameEn}}
                                        </td>
                                        <td class="groupHeaderLabelCell_ar">
                                            <strong class="bold-custom">{{'PLACENAME' | translate }}</strong>
                                        </td>
                                        <td class="groupHeaderDataCell_ar">
                                            {{translate.currentLang == 'ar' ? patient?.placeNameAr : patient?.placeNameEn}}
                                        </td>
                                    </tr>
                                </div>
                            </div>
                        </div>
                    </tbody>
                </table>
                <div class="main-tables">
                    <!-- vital data -->
                    <div *ngIf="!VitalsBlock &&  lastVitalData ">
                        <!-- vital data -->
                        <general-table [data]="vitalsDisplayType == 2 ? vitalsData : [lastVitalData]" [title]="'PATIENTVITALSDATA'" [docId]="patient?.docId" [type]="'t01'" [headColumns]="['VSPULSE','VSBP','VSTEMP', 'OXYOGENLEVEL', 'BLOODSUGER', 'VSRR', 'VSHEIGHT', 'VSWEIGHT', 'Notes', 'USERNAME', 'RegDate']"
                            [bodyColumns]="['pulse', 'highPressure', 'temperature','sat', 'bloodSuger', 'respiratory', 'height', 'weight', 'notes', 'userName', 'regDate']">
                        </general-table>
                    </div>
                    <div *ngFor="let table of tables">
                        <general-table *ngIf="table.selected" [data]="emrPatData[table.datakey]" [title]="table.title" [docId]="patient?.docId" [headColumns]="table.headColumns" [type]="table.type" [bodyColumns]="table.bodyColumns">
                        </general-table>
                    </div>

                </div>
            </div>
            <div id="labTestPrintView" [ngClass]="{'left-to-right': translate.currentLang != 'ar', 'right-to-left': translate.currentLang == 'ar'}" style="margin-top: 100px;" *ngIf="patServices.length > 0 && resultDisplayType == 2 && !OrderBlock">
                <h5 style="background: #ddd !important;width: fit-content;padding: 10px 15px;margin: 10px auto;">
                    {{translate.currentLang == 'ar' ? 'تفاصيل نتائج المعمل' : 'Lab Result Details'}}</h5>
                <div class="wrapper">
                    <table class="full-width" style="display: none;">
                        <tbody>
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">{{'PATNAMEAR' | translate }}</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">
                                    {{translate.currentLang == 'ar' ? patientData?.patientNameAr:patientData?.patientNameEn}}
                                </td>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">{{'AGE' | translate}} </strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{patientData?.patientAge }}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">{{'MRN' | translate}}</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{patientData?.patCode}}</td>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">{{'DOCTOR' | translate}}</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">
                                    {{translate.currentLang == 'ar' ? patientData?.doctorNameAr: patientData?.doctorNameEn}}
                                </td>
                            </tr>
                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">{{'ORDERSERIAL' | translate}}</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{patientData?.orderNumber}}</td>

                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">{{'REQDATE' | translate}}</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">
                                    {{patientData?.orderDate|date: 'hh:mm:ss a dd/MM/yyyy '}}</td>
                            </tr>

                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">{{translate.currentLang == 'ar' ? 'تاريخ النتيجه' : 'Result Date'}}</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">
                                    {{patientData?.expectedStartTime | date:'hh:mm:ss a dd/MM/yyyy ' }}
                                </td>

                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">{{translate.currentLang == 'ar' ? 'رقم المعمل' : 'Lab Number'}}</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{patientData?.OrderPlace}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->

                        </tbody>
                    </table>
                    <p>~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
                    <div *ngIf="labDataType == 2">
                        <div *ngFor="let service of patServices">
                            <h4 class="reportTitle_ar">
                                -{{translate.currentLang == 'ar' ? service.serviceNameAr : service.serviceNameEn}}
                            </h4>
                            <table style="direction: ltr;" class="full-width" *ngIf="testData?.length != 0">
                                <thead>
                                    <tr>
                                        <th class="groupHeaderLevel1_ar">
                                            <u>Test</u>
                                        </th>
                                        <th colspan="2" class="groupHeaderLevel1_ar">
                                            <u>Result</u>
                                        </th>
                                        <th class="groupHeaderLevel1_ar">
                                            <u>Reference Range</u>
                                        </th>
                                        <th class="groupHeaderLevel1_ar">
                                            <u>Comments</u>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <ng-template ngFor let-sheet [ngForOf]="testData">
                                        <tr *ngIf="sheet.sheetVisiable && service.regPatServiceSerial == sheet.regPatServiceSerial">
                                            <td class="detailBand_ar">- {{sheet.sheetNameAr}}</td>
                                            <td class="detailBand_ar reportTitle_ar">
                                                <b [style.color]="sheet.abnormality == 0 && sheet.itemType != 3?'red':''">
                                                    <ng-container *ngIf="sheet.itemType != 3 && sheet.sheetValue">
                                                        {{sheet.resultValue}}</ng-container>
                                                    <ng-container *ngIf="sheet.itemType == 3">{{sheet.sheetOptionAr}}
                                                    </ng-container>
                                                </b>
                                            </td>
                                            <td class="detailBand_ar reportTitle_ar">
                                                <b style="color:red;" *ngIf="sheet.abnormality == 0">{{sheet.valueStatus}}</b>
                                            </td>
                                            <td class="detailBand_ar reportTitle_ar">{{sheet.refValue}}</td>
                                            <td class="detailBand_ar reportTitle_ar">
                                                <ul *ngIf="sheet.comments.length > 0">
                                                    <li *ngFor="let comment of sheet.comments">
                                                        <small>{{comment.commentDescEn}}</small>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="2">
                                            <br>
                                            <!---------------------------------------------------------------------------->
                                            <ul class="list-group" *ngIf="serviceComment.length > 0">
                                                <li class="list-group-item active">Comments:</li>
                                                <li class="list-group-item" *ngFor="let comment of serviceComment">
                                                    <span *ngIf="service.regPatServiceSerial == comment.regPatServiceSerial">{{comment.nameEn}}</span>
                                                </li>
                                            </ul>
                                            <!---------------------------------------------------------------------------->
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="labDataType == 1">
                        <div>
                            <h4 class="reportTitle_ar">
                                -{{translate.currentLang == 'ar' ? lastlabDetailsResult.serviceNameAr : lastlabDetailsResult.serviceNameEn}}
                            </h4>
                            <table style="direction: ltr;" class="full-width" *ngIf="testData?.length != 0">
                                <thead>
                                    <tr>
                                        <th class="groupHeaderLevel1_ar">
                                            <u>Test</u>
                                        </th>
                                        <th colspan="2" class="groupHeaderLevel1_ar">
                                            <u>Result</u>
                                        </th>
                                        <th class="groupHeaderLevel1_ar">
                                            <u>Reference Range</u>
                                        </th>
                                        <th class="groupHeaderLevel1_ar">
                                            <u>Comments</u>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <ng-template ngFor let-sheet [ngForOf]="testData">
                                        <tr *ngIf="sheet.sheetVisiable && lastlabDetailsResult.regPatServiceSerial == sheet.regPatServiceSerial">
                                            <td class="detailBand_ar">- {{sheet.sheetNameAr}}</td>
                                            <td class="detailBand_ar reportTitle_ar">
                                                <b [style.color]="sheet.abnormality == 0 && sheet.itemType != 3?'red':''">
                                                    <ng-container *ngIf="sheet.itemType != 3 && sheet.sheetValue">
                                                        {{sheet.resultValue}}</ng-container>
                                                    <ng-container *ngIf="sheet.itemType == 3">{{sheet.sheetOptionAr}}
                                                    </ng-container>
                                                </b>
                                            </td>
                                            <td class="detailBand_ar reportTitle_ar">
                                                <b style="color:red;" *ngIf="sheet.abnormality == 0">{{sheet.valueStatus}}</b>
                                            </td>
                                            <td class="detailBand_ar reportTitle_ar">{{sheet.refValue}}</td>
                                            <td class="detailBand_ar reportTitle_ar">
                                                <ul *ngIf="sheet.comments.length > 0">
                                                    <li *ngFor="let comment of sheet.comments">
                                                        <small>{{comment.commentDescEn}}</small>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="2">
                                            <br>
                                            <!---------------------------------------------------------------------------->
                                            <ul class="list-group" *ngIf="serviceComment.length > 0">
                                                <li class="list-group-item active">Comments:</li>
                                                <li class="list-group-item" *ngFor="let comment of serviceComment">
                                                    <span *ngIf="lastlabDetailsResult.regPatServiceSerial == comment.regPatServiceSerial">{{comment.nameEn}}</span>
                                                </li>
                                            </ul>
                                            <!---------------------------------------------------------------------------->
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="radTestPrintView" [ngClass]="{'left-to-right': translate.currentLang != 'ar', 'right-to-left': translate.currentLang == 'ar'}" style="margin-top: 100px;" *ngIf="emrPatData.RadResults?.length > 0 && radResultType == 2 && !OrderBlock">
                <h5 style="background: #ddd !important;width: fit-content;padding: 10px 15px;margin: 10px auto;">
                    {{translate.currentLang == 'ar' ? 'تفاصيل نتائج الآشعة' : 'Rad Result Details'}}</h5>
                <div class="wrapper">
                    <p>~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
                    <div *ngIf="radDataType == 2">
                        <div *ngFor="let radResult of emrPatData.RadResults">
                            <div class="zxc" [innerHTML]="radResult.htmlContent"></div>
                        </div>
                    </div>
                    <div *ngIf="radDataType == 1">
                        <div class="zxc" [innerHTML]="lastRadDetailsResult.htmlContent"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-print-page #printFileComponent section="sectionwewe23232332"></app-print-page>
</div>

<style>
    .tbt {
        box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.25);
        border-radius: 7px 7px 20px 20px;
    }

    .tbt td {
        vertical-align: middle !important;
        color: #25b982 !important;
    }

    .tbt th {
        color: teal !important;
        padding-left: 25px;
        padding-right: 25px;
    }

    .cvc::after {
        background-color: #25b982 !important;
    }
</style>
